export const ENV_MODE = import.meta.env.VITE_ENV || import.meta.env.MODE;

export const PLATFORM_CODE = import.meta.env.VITE_PLATFORM_CODE;
export const SVC_PP_GQ_API_KEY = import.meta.env.VITE_SVC_PP_GQ_API_KEY;

export const RAZORPAY_CHECKOUT_SCRIPT = import.meta.env.VITE_RAZORPAY_CHECKOUT_SCRIPT;

export const SVC_PP_API_BASE_URL = import.meta.env.VITE_SVC_PP_API_BASE_URL;
export const ERP_API_BASE_URL = import.meta.env.VITE_ERP_API_BASE_URL;
export const CUSTOMER_API_BASE_URL = import.meta.env.VITE_CUSTOMER_API_BASE_URL;
export const NOTIFY_API_BASE_URL = import.meta.env.VITE_NOTIFY_API_BASE_URL;

export const PAYMENT_PAGE_BASE_URL = import.meta.env.VITE_PAYMENT_PAGE_BASE_URL;
export const CUSTOMER_PORTAL_BASE_URL = import.meta.env.VITE_CUSTOMER_PORTAL_BASE_URL;
export const PG_TERMS_AND_CONDITIONS_URL = import.meta.env.VITE_PG_TERMS_AND_CONDITIONS_URL;
export const PG_PRIVACY_POLICY_URL = import.meta.env.VITE_PG_PRIVACY_POLICY_URL;
export const ERP_SCRIPT_SOURCE = import.meta.env.VITE_ERP_SCRIPT_SOURCE;
export const SDK_ENV = import.meta.env.VITE_SDK_ENV;
export const MIN_EMI_AMOUNT = import.meta.env.VITE_MIN_EMI_AMOUNT;
export const MIN_AUTO_DEBIT_AMOUNT = import.meta.env.VITE_MIN_AUTO_DEBIT_AMOUNT;
export const MIN_DIRECT_AMOUNT = import.meta.env.VITE_MIN_DIRECT_AMOUNT;

export const DISABLE_ANALYTICS = import.meta.env.VITE_DISABLE_ANALYTICS;
export const MIX_PANEL_CODE = import.meta.env.VITE_MIX_PANEL_CODE;
export const MIX_PANEL_ENABLED = import.meta.env.VITE_MIX_PANEL_ENABLED;
